import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import {environment} from "../../../../../environments/environment";
import {
  LLMSettings,
  TestResult,
  TestMetrics
} from '../models/llm-test-scenario.interface';

@Injectable({
  providedIn: 'root'
})
export class LlmTestService {
  private readonly CHAT_ENDPOINT = 'admin/chat';
  public lastTestMetrics: TestMetrics | null = null;

  constructor(private http: HttpClient) { }

  testPromptWithParameters(testParams: any): Observable<TestResult> {
    const startTime = Date.now();

    // HTTP headers
    const headers = new HttpHeaders({
      'Accept': 'application/json'
    });

    // FormData oluştur
    const formData = new FormData();

    // Temel parametreleri ekle
    formData.append('prompt', testParams.prompt);
    if (testParams.question) formData.append('question', testParams.question);
    if (testParams.data_ids) formData.append('data_ids', JSON.stringify(testParams.data_ids));
    if (testParams.organization_id) formData.append('organization_id', testParams.organization_id.toString());
    formData.append('model_ids', JSON.stringify(testParams.model_ids));
    formData.append('temperature', testParams.temperature.toString());
    formData.append('tone', testParams.tone);

    // Dosyaları ekle
    if (testParams.files && testParams.files.length > 0) {
      testParams.files.forEach((file: File, index: number) => {
        formData.append(`files`, file);
      });
    }

    return this.http.post<any>(`${environment.chatApiUrl}/${this.CHAT_ENDPOINT}`, formData, { headers })
      .pipe(
        map(response => {
          const endTime = Date.now();

          // Test parametrelerinden settings oluştur
          const settings: LLMSettings = {
            model: testParams.model_ids[0],
            temperature: testParams.temperature,
            tone: testParams.tone
          };

          const metrics: TestMetrics = {
            inputTokens: response.metrics?.input_tokens || response.tokens_used || 0,
            outputTokens: response.metrics?.output_tokens || 0,
            totalTokens: response.metrics?.total_tokens || 0,
            responseTime: endTime - startTime
          };

          this.lastTestMetrics = metrics;

          let responseText = response.response || response.message || 'API yanıtı alınamadı';

          const result: TestResult = {
            settings,
            prompt: testParams.prompt,
            userQuestion: testParams.question,
            response: responseText,
            metrics,
            timestamp: new Date()
          };

          // API yanıtındaki ek bilgileri result nesnesine ekle
          (result as any).tokens_used = response.tokens_used;
          (result as any).response_start_latency = response.response_start_latency;
          (result as any).response_complete_latency = response.response_complete_latency;
          return result;
        }),
        catchError(error => {
          const settings: LLMSettings = {
            model: testParams.model_ids[0],
            temperature: testParams.temperature,
            tone: testParams.tone
          };

          const errorResult: TestResult = {
            settings,
            prompt: testParams.prompt,
            userQuestion: testParams.question,
            response: `API hatası: ${error.message || 'Bilinmeyen hata'}`,
            metrics: {
              inputTokens: 0,
              outputTokens: 0,
              totalTokens: 0,
              responseTime: Date.now() - startTime
            },
            timestamp: new Date()
          };

          return of(errorResult);
        })
      );
  }




}
